
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CitiesMasterGrid extends Serenity.EntityGrid<CitiesMasterRow, any> {
        protected getColumnsKey() { return 'OMS.CitiesMaster'; }
        protected getDialogType() { return CitiesMasterDialog; }
        protected getIdProperty() { return CitiesMasterRow.idProperty; }
        protected getLocalTextPrefix() { return CitiesMasterRow.localTextPrefix; }
        protected getService() { return CitiesMasterService.baseUrl; }
        protected getInsertPermission() { return CitiesMasterRow.insertPermission; }
        protected getUpdatePermission() { return CitiesMasterRow.updatePermission; }
        protected getDeletePermission() { return CitiesMasterRow.deletePermission; }
        protected useViewMode() { return true; }


        constructor(container: JQuery) {
            super(container);
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}